
import Vue from "vue";
import DialogSuccess from "./dialog/success/success.vue";
import DialogWarning from "./dialog/warning/warning.vue";
import { imamHussainAPI } from "@/api";

export default Vue.extend({
  name: "imam-hussain-ziarat-register",

  components: {
    DialogSuccess,
    DialogWarning,
  },
  data() {
    return {
      openDialogSuccess: false,
      openDialogWarning: false,
      errorMessage: null,
      snackbar: false,
      form: {
        applicantName: "",
        cellphone: "",
        description: "",
        token: '',
        // recaptcha: "",
      },
      nameRules: [
        (value) => !!value || "فیلد اجباری می باشد",
        (value) =>
          value?.length > 6 ||
          "نام و نام خانوادگی نمی تواند کمتر از 6 کاراکتر باشد",
      ],
      descriptionRules: [
        (value) => !!value || "فیلد اجباری می باشد",
        (value) =>
          value?.length > 10 || "متن نیت نمی تواند کمتر از 10 کاراکتر باشد",
      ],
      mobileRules: [
        (value) => !!value || "فیلد اجباری می باشد",
        (value) => /^09\d{9}$/.test(value) || "شماره همراه صحیح نمی باشد",
      ],
      keyboardHeight: 16,
    };
  },

  methods: {
    onVerifyCaptcha(data) {
      // this.form.recaptcha = data;
    },

    onErrorCaptcha() {
      // this.form.recaptcha = "";
    },
    handleBlurInput() {
      this.handleKeyboardHeight(16);
    },
    handleFocusInput() {
      this.handleKeyboardHeight(300);
    },
    handleKeyboardHeight(height: number) {
      setTimeout(() => {
        this.keyboardHeight = height;
      }, 0);
    },
    save() {
      if (!(this.$refs.form as any).validate()) return;
      const params = { ...this.form };
      params.token = this.$store.state.queryParams?.token;

      this.$store.commit("showLoading", true);
      imamHussainAPI
        .ziaratRegister(params)
        .then((res) => {
          this.openDialogSuccess = true;
          (this.$refs.form as any).reset();
        })
        .catch((err) => {
          if (err.response.status === 429) {
            this.openDialogWarning = true;
            return;
          }
          this.snackbar = true;
          this.errorMessage = "خطا در پردازش اطلاعات، لطفا مجددا سعی نمائید";
        })
        .finally(() => {
          this.$store.commit("showLoading", false);
        });
    },
  },
});
